import Vue from 'vue'
import VueRouter from 'vue-router'

import helpers from '../utils/helpers'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Films from '../views/Films.vue'
import Film from '../views/Film.vue'
import Search from '../views/Search.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登錄'
    }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      needAuth: true
    }
  },
  {
    path: '/films/:id',
    name: 'Films',
    component: Films,
    meta: {
      needAuth: true,
      title: '精選電影'
    }
  },
  {
    path: '/film/:id',
    name: 'Film',
    component: Film,
    meta: {
      needAuth: true
    }
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    meta: {
      needAuth: true,
      title: '搜索結果'
    }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  helpers.setTitle(to.meta.title)

  scrollTo(0, 0)

  if (to.meta.needAuth && !localStorage.user) {
    next({ name: 'Login', query: { url: to.path } })
  } else {
    next()
  }
})

export default router
